var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAlvotechBasket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#222222;}\n\t.st1{fill:#F69D25;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#F69D25;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#222222;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pipline"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "biosimilar"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "employees"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "network"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "generic-projects"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "manufacturing-centers"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "key-growth"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "molecule"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "green"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "map"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "playground"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "microscope"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "basket"
  }, /*#__PURE__*/React.createElement("path", {
    id: "neutral_13_",
    className: "st3",
    d: "M450.2,241h-28.5v-19.7c0-22.6-20.2-99-42.6-134.1c8.7-1.3,15.5-8.8,15.5-17.9V42.2 c0-10-8.1-18.1-18.1-18.1h-90.4c-10,0-18.1,8.1-18.1,18.1v27.1c0,8.8,6.4,16.2,14.8,17.8c-14,22.1-25.7,59.1-31.1,78l-12.6-7.1 c-3.5-2-7.8-1.4-10.7,1.3l-12.2,11.5c-16.7-14.4-37.8-22.2-60.1-22.2c-51.1,0-90,39.4-92.3,92.4h-14c-14.2,0-25.7,11.5-25.7,25.7 v29.9c0,14.2,11.5,25.7,25.7,25.7h1.4v27.1c0,1.8,0,2.8,31,103.4c0.2,0.6,0.8,1.9,1.1,2.4c5.4,9.7,11.5,20.6,24.2,20.6h285 c15.7,0,21.3-13.4,25.3-23.1c31-100.6,31-101.7,31-103.4v-27.1h1.4c14.2,0,25.7-11.5,25.7-25.7v-29.9 C475.9,252.5,464.4,241,450.2,241z M286.1,42.2h90.4v27.1h-90.4V42.2z M305.1,87.4h52c12.7,8.2,46.5,99.6,46.5,133.9V241h-18.1 c-0.1-0.1-0.2-0.1-0.4-0.2l-117.2-66.5C279.9,130.7,297.4,92.3,305.1,87.4z M236.1,177l112.8,64H168.4L236.1,177z M156.2,166.6 c17.3,0,33.7,5.9,46.9,16.7l-61,57.7H81.9C84.2,198.2,115.3,166.6,156.2,166.6z M367.5,322.3h63.2v26c-2.2,7.9-19,62.8-29.9,98.4 c-4.2,10.1-5.8,11.1-8.3,11.1h-285c-2,0-5.5-6.1-8.3-11.2c-11.2-36.4-27.8-90.4-29.9-98.3v-26h63.2 M304.2,322.3h18.1 M241,322.3 H259 M177.7,322.3h18.1 M150.6,322.3h9 M213.9,322.3h9 M277.1,322.3h9 M340.4,322.3h9 M457.8,296.6c0,4.2-3.4,7.6-7.6,7.6H49.8 c-4.2,0-7.6-3.4-7.6-7.6v-29.9c0-4.2,3.4-7.6,7.6-7.6h400.3c4.2,0,7.6,3.4,7.6,7.6V296.6z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "color_7_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M160.3,421.7h-9v-99.4h-18.1v108.4c0,5,4,9,9,9h27.1c5,0,9-4,9-9V322.3h-18.1V421.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M223.5,421.7h-9v-99.4h-18.1v108.4c0,5,4,9,9,9h27.1c5,0,9-4,9-9V322.3h-18.1V421.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M286.8,421.7h-9v-99.4h-18.1v108.4c0,5,4,9,9,9h27.1c5,0,9-4,9-9V322.3h-18.1V421.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M350,421.7h-9v-99.4h-18.1v108.4c0,5,4,9,9,9h27.1c5,0,9-4,9-9V322.3H350V421.7z"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "hand-pill"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "cosmetics"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "medical"
  })));
}

export default SvgAlvotechBasket;